import { firePanelAction } from '../actions/firePanelAction';
import { TActionResult, panelActionsEmitter } from '../actions/usePanelActions';
import { TPanelId } from '../types';
import {
  TParamsStore,
  parametersActions,
  parametersStore,
} from './parametersStore';

/**
 * Actualiza los parámetros de un panel a nivel de cliente. Este método se
 * expone con el único fin de ser llamado por la acción saveParams del api.
 */
export function saveParameters(
  panelId: TPanelId,
  parameters: TParamsStore,
  refresh = true,
) {
  parametersStore.dispatch(parametersActions.udpate({ panelId, parameters }));
  if (refresh) {
    panelActionsEmitter.emit(panelId, 'configurationApply', {
      data: parameters,
    } as TActionResult);
    firePanelAction(panelId, 'refresh');
  }
}
